import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { message, Popconfirm } from "antd";
import { formatMoney } from "../../App";
import { Spin } from "antd";
import "./TableComp.css";
import NotfoundIcon from "../../Images/NotFound.svg";
import { withRouter } from 'react-router-dom';

// standard icons
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import more from "../../Images/more.svg"

import { apiurl } from "../../App";
import DateData from "../../component/Revenue/DateData.js";
import moment from "moment";
import axiosInstance from "../../api/axiosInstance";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headRows = [
    { id: "sno", label: "S.No" },
    { id: "patient", label: "Customer" },
    { id: "gender", label: "Gender" },
    { id: "age", label: "Age" },
    { id: "time", label: "Time" },
    { id: "service", label: "Service" },
    { id: "action", label: "Action" },
  ];

  const isAvailableToSort = (row) => {
    return (
      row.label.toLowerCase() == "s.no" ||
      row.label.toLowerCase() == "action" ||
      row.id.toLowerCase() === "action"
    );
  };

  return (
    <TableHead className={props.alignheading}>
      {/* <TableRow>
        dfghj
      </TableRow> */}

      <TableRow>
        {props.heading.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? order : false}
          >
            {/* {row.label} */}
            {
              row.label === "Rate (INR)" || row.label === "Rate (KWD)" ? (
                <span>
                  Rate<span style={{ fontSize: "10px" }}> ({localStorage.getItem("currency") || "₹"})</span>
                </span>
              ) : row.label === "Approved Status (By Sales Admin)" ? (
                localStorage.pharmacy_language == 'ar' ? (
                  < span >
                    الحالة المعتمدة<span style={{ fontSize: "10px" }}> (By tom Sales Admin)</span>
                  </span>
                ) : (
                  < span >
                    Approved Status<span style={{ fontSize: "10px" }}> (By tom Sales Admin)</span>
                  </span>
                ) 

              ) : row.label === "Unit Rate " || row.label === "Unit Rate" ? (
                <span>
                  Unit Rate<span style={{ fontSize: "10px" }}> ({localStorage.getItem("currency") || "₹"})</span>
                </span>
              ) : row.label === "Fee (INR)" || row.label === "Fee (KWD)" ? (
                localStorage.pharmacy_language == 'ar' ? (
                  < span >
                  مصاريف<span style={{ fontSize: "10px" }}> (د.ك)</span>
                  </span>
                ) : ( 
                  <span>
                  Fee<span style={{ fontSize: "10px" }}> ({localStorage.getItem("currency") || "₹"})</span>
                </span>
                )
           
              ) : row.label === "tom Share (INR)" || row.label === "tom Share (KWD)" ? (
                localStorage.pharmacy_language == 'ar' ? (
                  < span >
                   <span style={{ fontSize: "10px" }}> (د.ك)</span>يشارك tom
                  </span>
                ) : ( 
                   <span>
                  tom Share<span style={{ fontSize: "10px" }}> ({localStorage.getItem("currency") || "₹"})</span>
                </span>
                )

              ) : row.label === "Income (INR)" || row.label === "Income (KWD)" ? (
                   localStorage.pharmacy_language == 'ar' ? (
                  < span >
                   دخل<span style={{ fontSize: "10px" }}> (د.ك)</span>
                  </span>
                ) : ( <span>
                  Income<span style={{ fontSize: "10px" }}> ({localStorage.getItem("currency") || "₹"})</span>
                </span>
                )
)
                :
                (
                  <span>{row.label}</span>
                )
            }
            {/* {!isAvailableToSort(row) ? (
              <TableSortLabel
                hideSortIcon={
                  row.label.toLowerCase() == "s.no" ||
                  row.label.toLowerCase() == "action" ||
                  row.id.toLowerCase() === "action"
                    ? true
                    : false
                }
                active={orderBy === row.id}
                direction={order}
                onClick={createSortHandler(row.id)}
              >
                {row.label}
              </TableSortLabel>
            ) : (
              row.label
            )} */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead >
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};



const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true,
})(TablePaginationActions);



class Tablecomponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "",
      open: false,
      orderBy: "media_title",
      selected: [],
      page: 0,
      dense: false,
      rowsPerPage: 5,
      viewmodal: false,
      rows: this.props.rowdata,
      viewdata: null,
      type: "",
      title: "",
      data12: ["", "", "", "total", "price"]
    };
  }

  closemodal = () => {
    this.setState({ view: false, DeleteView: false });
  };
  handleClick = (event, name, row) => {
    const selectedIndex = this.state.selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected.push(this.state.selected, name);
    } else if (selectedIndex === 0) {
      // newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === this.state.selected.length - 1) {
      // newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      // newSelected = newSelected.concat(
      //   selected.slice(0, selectedIndex),
      //   selected.slice(selectedIndex + 1),
      // );
    }
    this.setState({ selected: newSelected });

    if (this.props.oncliking === 'RevenueAndSettlement') {
      if (row?.id?.props?.children) {
        // const { history } = this.props;
        // history.push(`/home/revenueChart/medlist/${row.id}`);
        // DateData.setdate(this.props.StartDate,this.props.EndDate,'true','settlementkw')
        this.props.history.push(`/home/revenueChart/medlist/0/0/${row?.id?.props?.children}`);
      } else if (row.id) {
        // DateData.setdate(this.props.StartDate,this.props.EndDate,'true','settlementkw')
        this.props.history.push(`/home/revenueChart/medlist/0/0/${row?.id}`);
      }
      const { getMemberDetails } = this.props;
      getMemberDetails({
        memberID: 302,
        isOnclickMember: true
      });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  handleChangeDense(event) {
    this.setState({ dense: event.target.checked });
  }

  receiveapprovaldata = (data, data1) => {
    if (data1 == 1) {
      this.setState({ viewmodal: false });
      message.success("Your Leave Approved");
      this.loadVendorDetails();
    } else if (data1 == 2) {
      this.setState({ viewmodal: false });
      message.success("Your Leave Rejected");
      this.loadVendorDetails();
    }
  };
  receivedocdelete = (data) => {
    if (data.status == 0) {
      this.setState({ viewmodal: false });
      message.success(data.msg);
      this.loadDoctorDetails();
    }
  };
  sendapprovadata = (data) => {
    if (data.status == 0) {
      this.setState({ viewmodal: false });
      message.success(data.msg);
      this.loadDoctorDetails();
    }
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    let tablebodydata = this.props.rowdata;
    this.setState({
      rows: newProps.rowdata,
    });
  }

  sendMedicineAlert = () => {
    var reqData = {
      pharmacy_id: localStorage.getItem("pharmacy_id")
    }
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/sendAlertSalesAdiminMedicineApproval",
      data: reqData
    }).then((response) => {
      if (response.data.msg !== "Failed") {
        const { t } = this.props;
        const alert_sent_successfully = t("alert_sent_successfully");
        this.props.handleopenSuccess(alert_sent_successfully, true)
      }
      else {
        this.props.handleopenSuccess("Alert send failed", false)
      }
      this.props.getTableData();
    })
  };


  render() {
    const isSelected = (name) => this.state.selected.indexOf(name) !== -1;
    const { rows, rowsPerPage, page } = this.state;
    const { t } = this.props;
    // debugger
    console.log("=========================================>>>>>>>>>", rows, this.props.heading)
    return (
      <Spin className="spinner_align" spinning={this.props.props_loading}>
        <div className={`VendorDetailsDiv ${this.props.tablemasterclass}`}>
          {/* <Paper className="paper"> */}
          <div className="tableWrapper">
            {/* {
              this.props.modeprop &&
              <div className="modeOfPayment">
                <span className="modeOfPaymentText">Mode of Payment</span>
              </div>
            } */}
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={this.state.dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={this.state.selected.length}
                order={this.state.order}
                orderBy={this.state.orderBy}
                // onSelectAllClick={this.handleSelectAllClick}
                heading={this.props.heading}
                rowCount={this.state.rows && this.state.rows.length}
                alignheading={this.props.alignheading}
              />
              {
                this.props.isHeadingButton &&
                <TableHead className="buttonHeadtitle">
                  <TableRow>
                    {this.props.HeadingButton.map((row, id) => (
                      <TableCell key={id}><span className={row.label ? (row.type == 'tomshare' ? "HeadingButton2" : "HeadingButton") : ""}>{row != '' ? formatMoney(Number(row.label)) : row.label}</span></TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              }
              <TableBody>
                {this.state.rows.length === 0 && (
                  <TableCell className={"noFoundIconCenter"} colSpan={12}>
                    <img src={NotfoundIcon} />
                    <div>{this.props?.DataFound ? this.props.DataFound : t("no_data_found")}</div>
                  </TableCell>
                )}
                {stableSort(
                  this.state.rows,
                  getSorting(this.state.order, this.state.orderBy)
                )
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  .map((row, index, item) => {
                    const isItemSelected = isSelected(row.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        onClick={(event) => { this.handleClick(event, row.name, row); this.props?.newDateGet && this.props.newDateGet({ startDate: this.props?.startDate, endDate: this.props?.EndDate }) }}
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                        {localStorage.pharmacy_language !== "ar" ? (<TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {this.state.rowsPerPage * this.state.page -
                            1 +
                            index +
                            2}
                        </TableCell>) : (this.props.actionclose === "close" ? null : (
                          <TableCell
                            className={`${this.props.tableicon_align}`}
                            style={{
                              display: (localStorage.pharmacy_language == 'ar' ? '' : 'flex'),
                              flexDirection: (localStorage.pharmacy_language == 'ar' ? '' : 'row-reverse')
                            }}
                          >

                            <div className="arabRow">
                              {this.props.ShowTicketButton && row.status != 'Resolved' && row.status != 'Pending' ? (
                                <div style={{
                                  display: 'flex', float: 'left',
                                  direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : ''),
                                  justifyContent: (localStorage.pharmacy_language == 'ar' ? 'center' : ''),
                                  width: (localStorage.pharmacy_language == 'ar' ? '100%' : ''),
                                }}>
                                  <div className={row.status == "Reopened" ? "ticket_reopen reopen_status" : "ticket_reopen"} onClick={() => this.props.modelopen && this.props.modelopen("reopen", row.id)}>
                                    {/* Reopen */}
                                    {t("reopen")}
                                  </div>
                                  <div className="ticket_resolved" onClick={() => this.props.modelopen("resolved", row.id)}> 
                                  {/* Resolve */}
                                  {t("resolved")}
                                  </div>
                                </div>
                              ) : null}
                              {this.props.AddBox === true && (
                                <AddIcon
                                  className="Plus_icon mr-2"
                                  onClick={() =>
                                    this.props.modelopen("add", row.id)
                                  }
                                />
                              )}
                              {this.props.VisibilityIcon === "close" ? null : (
                                <img src={more}
                                  className="tableeye_icon"
                                  onClick={() =>
                                    this.props.modelopen("view", row.id)
                                  }
                                />
                              )}
                              {row.salesApprovalSts == "A" || this.props.EditIcon === "close" ? null : (
                                <EditIcon
                                  className="tableedit_icon"
                                  onClick={() =>
                                    this.props.modelopen("edit", row.id)
                                  }
                                />
                              )
                              }
                              {this.props.DeleteIcon === "close" ? null : (
                                <DeleteIcon
                                  className="tabledelete_icon"
                                  onClick={() =>
                                    this.props.deleteopen("delete", row.id)
                                  }
                                />
                              )}
                            </div>
                          </TableCell>
                        ))}

                        {[row].map((data, index) => {
                          var keys = (localStorage.pharmacy_language == 'ar' ? Object.keys(data).reverse() : Object.keys(data));
                          var arrval = [];
                          let first_value = localStorage.pharmacy_language == 'ar' ? 1 : 0;
                          let condition = localStorage.pharmacy_language == 'ar' ? keys.length : keys.length - 1;
                          for (var m = first_value; m < condition; m++) {
                            if (keys === "") {
                              console.log("keys", keys[m], data[keys[m]]);
                            }
                            arrval.push(
                              <TableCell key={data.id + "" + m}>
                                <span> {keys[m] == "salesApprovalSts" ? data.salesApprovalSts == "A" ? "Approved" : "" : ""}</span>
                                {(keys[m] == "salesApprovalSts" && data.salesApprovalSts == "P") &&
                                  <div className="pending_status_alert">
                                    <span > {keys[m] == "salesApprovalSts" ? data.salesApprovalSts == "P" ? "Pending" : "" : ""}</span>
                                    <p className="alert"
                                      style={{ left: (localStorage.pharmacy_language == 'ar' ? '-55px' : '55px') }}
                                      onClick={this.sendMedicineAlert}>Send Alert</p>
                                  </div>
                                }
                                <span className="status_medicine"> {keys[m] == "salesApprovalSts" ? data.salesApprovalSts == "R" ? "Rejected" : "" : ""}</span>
                                <span> {keys[m] != "salesApprovalSts" ? data[keys[m]] : ""}</span>
                              </TableCell>
                            );
                          };
                          return arrval;
                        })}
                        {localStorage.pharmacy_language !== "ar" ? (this.props.actionclose === "close" ? null : (
                          <TableCell
                            className={`${this.props.tableicon_align}`}
                            style={{ display: "flex", justifyContent: "start" }}
                          >
                            <div className="rowReverse">
                              {this.props.ShowTicketButton && row.status != 'Resolved' && row.status != 'Pending' ? (
                                <div style={{ display: 'flex', float: 'left', justifyContent: 'center', width: '100%' }}>
                                  <div className={row.status == "Reopened" ? "ticket_reopen reopen_status" : "ticket_reopen"} onClick={() => this.props.modelopen("reopen", row.id)}>
                                     {/* Reopen */}
                                     {t("reopen")}
                                     </div>
                                  <div className="ticket_resolved" onClick={() => this.props.modelopen("resolved", row.id)}>
                                    {/* Resolve */}
                                    {t("resolved")}
                                    </div>
                                </div>
                              ) : null}
                              {this.props.AddBox === true && (
                                <AddIcon
                                  className="Plus_icon mr-2"
                                  onClick={() =>
                                    this.props.modelopen("add", row.id)
                                  }
                                />
                              )}
                              {this.props.VisibilityIcon === "close" ? null : (
                                <img src={more}
                                  className="tableeye_icon"
                                  onClick={() =>
                                    this.props.modelopen("view", row.id)
                                  }
                                />
                              )}
                              {row.salesApprovalSts == "A" || this.props.EditIcon === "close" ? null : (
                                <EditIcon
                                  className="tableedit_icon"
                                  onClick={() =>
                                    this.props.modelopen("edit", row.id)
                                  }
                                />
                              )}
                              {this.props.DeleteIcon === "close" ? null : (
                                <DeleteIcon
                                  className="tabledelete_icon"
                                  onClick={() =>
                                    this.props.deleteopen("delete", row.id)
                                  }
                                />
                              )}
                            </div>
                          </TableCell>
                        )) : (<TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {this.state.rowsPerPage * this.state.page -
                            1 +
                            index +
                            2}
                        </TableCell>)}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </div>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            colSpan={3}
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              native: true,
            }}
            component="div"
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActionsWrapped}
            labelRowsPerPage={t('rows_per_page')}
          />

          {/* </Paper> */}
        </div>
      </Spin>
    );
  }
}
export default withRouter(Tablecomponent);
